import React, { useState, useEffect } from 'react'
import {
  Panel,
  InputNumber,
  Grid,
  Row,
  Col,
  Input,
  InputGroup,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  SelectPicker,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
  Message,
} from 'rsuite'
import { requiredFiled, isValidators } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import { cloneDeep } from 'lodash'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import NumberFormat from 'react-number-format'
import InputForm from '../../../../components/forms/input/InputForm'

export default function PromoteEatingFruitsAndVegetablesForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const [studentHealth, setStudentHealth] = useState({})
  const [activity, setActivity] = useState()
  const [activityForms, setActivityForms] = useState([])

  useEffect(() => {
    let studentHealth = {}

    studentHealth[schema.allStudents.name] = schema.allStudents.value
    studentHealth[schema.thin.name] = schema.thin.value
    studentHealth[schema.fat.name] = schema.fat.value
    studentHealth[schema.short.name] = schema.short.value
    studentHealth[schema.slim.name] = schema.slim.value
    studentHealth[schema.eatVegetableEnough.name] = schema.eatVegetableEnough.value
    studentHealth[schema.eatVegetableNotEnough.name] = schema.eatVegetableNotEnough.value
    studentHealth[schema.notEatVegetable.name] = schema.notEatVegetable.value
    studentHealth[schema.physicalActivity.name] = schema.physicalActivity.value

    setValue(schema.allStudents.name, schema.allStudents.value)
    setValue(schema.thin.name, schema.thin.value)
    setValue(schema.fat.name, schema.fat.value)
    setValue(schema.short.name, schema.short.value)
    setValue(schema.slim.name, schema.slim.value)
    setValue(schema.eatVegetableEnough.name, schema.eatVegetableEnough.value)
    setValue(schema.eatVegetableNotEnough.name, schema.eatVegetableNotEnough.value)
    setValue(schema.notEatVegetable.name, schema.notEatVegetable.value)
    setValue(schema.physicalActivity.name, schema.physicalActivity.value)

    setStudentHealth(studentHealth)

    let activityFs = [...schema.activityList.value]
    setValue(schema.activityList.name, activityFs)
    setActivityForms(activityFs)
    setActivity(schema.isActivity?.value)
  }, [schema])

  const createActivity = () => {
    return { activityName: '', activityResult: '' }
  }

  const addNewActivity = () => {
    let activityFs = [...activityForms]

    activityFs.push(createActivity())
    setActivityForms(activityFs)
  }

  const onDeleteActivity = (index) => {
    let activitys = [...activityForms]

    activitys.splice(index, 1)
    // console.log('activitys', activitys)
    setValue(schema.activityList.name, activitys)
    setActivityForms(activitys)
  }

  const calculatePercent = (name) => {
    var value = studentHealth[name]
    var all = studentHealth[schema.allStudents.name]
    return all && (value ? ((value * 100) / all).toFixed(2) : '')
  }

  const inputNumberGroup = (obj, preLabelStyle, col) => {
    return (
      <>
        {errors[obj.name] && (
          <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
            <ErrorMessage error={errors[obj.name]} />
          </Col>
        )}
        {obj.label && (
          <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
            <p>{obj.label}</p>
          </Col>
        )}
        <Col
          xs={24}
          sm={24}
          md={col ? col[0] : 24}
          lg={col ? col[0] : 24}
          style={styles.marginTop10}
        >
          <InputGroup>
            {obj.preLabel && (
              <InputGroup.Addon>
                <p style={preLabelStyle ? preLabelStyle : {}}>{obj.preLabel}</p>
              </InputGroup.Addon>
            )}
            <Controller
              key={obj.name}
              name={obj.name}
              control={control}
              rules={isValidators(obj.validators)}
              defaultValue={studentHealth[obj.name]}
              render={(props) => {
                // console.log('obj.name', studentHealth[obj.name], props.value)
                return (
                  // <InputNumber
                  //   disabled={obj.disabled}
                  //   // value={studentHealth[obj.name]}
                  //   value={props.value}
                  //   placeholder={obj.hint}
                  //   onChange={(value) => {
                  <NumberFormat
                    className="rs-input"
                    disabled={obj.disabled}
                    thousandSeparator={true}
                    value={props.value}
                    placeholder={obj.hint}
                    onValueChange={(e) => {
                      let value = e.floatValue
                      var studentHealthAll = studentHealth
                      studentHealthAll[obj.name] = value
                      setStudentHealth(studentHealthAll)

                      setValue(obj.name, value)
                      clearErrors(obj.name)
                    }}
                  />
                )
              }}
            />
            <InputGroup.Addon>
              <p>{obj.postLabel}</p>
            </InputGroup.Addon>
          </InputGroup>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={col ? col[1] : 24}
          lg={col ? col[1] : 24}
          style={styles.marginTop10}
        >
          <InputGroup style={styles.percentStyles}>
            <InputGroup.Addon>
              <p>{obj.percentLabel}</p>
            </InputGroup.Addon>
            <Input
              style={styles.percentDetailStyles}
              // name={keyName}
              disabled={true}
              placeholder="00.00"
              value={calculatePercent(obj.name)}
            />
          </InputGroup>
        </Col>
      </>
    )
  }

  const renderActivityInputForm = activityForms.map((item, index) => {
    return (
      <div key={index}>
        <Panel bordered style={{ marginBottom: 5 }}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
              <ControlLabel>
                <b>
                  {schema.activityForm.activity.label} {index + 1}
                </b>
              </ControlLabel>
              <Input
                value={item.activityName}
                name={schema.activityForm.activity.name + '_' + index}
                placeholder={schema.activityForm.activity.hint}
                inputRef={register(schema.activityForm.activity.validators)}
                onChange={(value) => {
                  let activitys = cloneDeep(activityForms)

                  activitys[index].activityName = value

                  setValue(schema.activityList.name, activitys)
                  setActivityForms(activitys)
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={schema.activityForm.result}
                rows={3}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                name={schema.activityForm.result.name + '_' + index}
                value={item.activityResult}
                onChange={(value) => {
                  let activitys = cloneDeep(activityForms) //[...activityForms]

                  activitys[index].activityResult = value

                  setValue(schema.activityList.name, activitys)
                  setActivityForms(activitys)
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={
                  <Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />
                }
                onClick={(e) => onDeleteActivity(index)}
              >
                ลบกิจกรรม
              </IconButton>
            </Col>
          </Row>
        </Panel>
      </div>
    )
  })

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            {schema.aboutSchool && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <CKEditorFrom
                  schema={schema.aboutSchool}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}
            {schema.promoteNutritionResult && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <CKEditorFrom
                  schema={schema.promoteNutritionResult}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 20 }}>
            <Col>{requiredFiled(schema.isActivity.validators, schema.isActivity.label)}</Col>
            <Col style={{ marginLeft: 25 }}>
              <Controller
                key={schema.isActivity.name}
                name={schema.isActivity.name}
                control={control}
                rules={isValidators(schema.isActivity.validators)}
                defaultValue={schema.isActivity.value}
                render={(props) => {
                  return (
                    <RadioGroup
                      inline
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        // if (value == 'N') {
                        //   setActivityForms([])
                        // }
                        setActivity(value)
                      }}
                    >
                      {schema.isActivity.options.map((item) => {
                        return <Radio value={item.value}>{item.label}</Radio>
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </Col>

            {activity == 'Y' && (
              <>
                <Col xs={24} sm={24} md={24} lg={24}>
                  {schema.isActivity.description && (
                    <Message
                      style={{ marginBottom: 10 }}
                      showIcon
                      type="info"
                      description={schema.isActivity.description}
                    />
                  )}

                  <Controller
                    key={schema.activityList.name}
                    name={schema.activityList.name}
                    control={control}
                    rules={isValidators(schema.activityList.validators)}
                    defaultValue={activityForms}
                  />
                  {renderActivityInputForm}
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                    onClick={(e) => addNewActivity()}
                    style={{ marginRight: 5 }}
                  >
                    เพิ่มกิจกรรม
                  </IconButton>
                </Col>
              </>
            )}

            <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
              {/* <p>{schema.studentHealthDetailText}</p> */}
              <p>
                <b>{schema.studentHealthInfoText}</b>
              </p>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24}>
              {inputNumberGroup(schema.allStudents, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.thin, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.fat, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.short, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.slim, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.eatVegetableEnough, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.eatVegetableNotEnough, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.notEatVegetable, styles.preLabelStyle, [8, 14])}
              {inputNumberGroup(schema.physicalActivity, styles.preLabelStyle, [8, 14])}
            </Col>

            {schema.sourceInfo && (
              <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
                <Form layout="inline">
                  <FormGroup>
                    <ControlLabel>
                      {requiredFiled(schema.sourceInfo.validators, schema.sourceInfo.label)}
                    </ControlLabel>
                    <Controller
                      key={schema.sourceInfo.name}
                      name={schema.sourceInfo.name}
                      control={control}
                      rules={isValidators(schema.sourceInfo.validators)}
                      defaultValue={schema.sourceInfo.value}
                      render={(props) => {
                        return (
                          <FormControl
                            value={props.value}
                            placeholder={schema.sourceInfo.hint}
                            onChange={(value) => {
                              setValue(schema.sourceInfo.name, value)
                              clearErrors(schema.sourceInfo.name)
                            }}
                          />
                        )
                      }}
                    />

                    <ControlLabel style={{ marginLeft: 10 }}>
                      {requiredFiled(
                        schema.sourceInfoMonth.validators,
                        schema.sourceInfoMonth.label
                      )}
                    </ControlLabel>
                    <Controller
                      key={schema.sourceInfoMonth.name}
                      name={schema.sourceInfoMonth.name}
                      control={control}
                      rules={isValidators(schema.sourceInfoMonth.validators)}
                      defaultValue={schema.sourceInfoMonth.value}
                      render={(props) => {
                        return (
                          <SelectPicker
                            size="lg"
                            style={{ width: 120, marginLeft: 10 }}
                            searchable={true}
                            value={props.value}
                            data={schema.sourceInfoMonth.options}
                            placeholder={schema.sourceInfoMonth.hint}
                            onChange={(value) => {
                              setValue(schema.sourceInfoMonth.name, value)
                            }}
                          />
                        )
                      }}
                    />

                    <ControlLabel style={{ marginLeft: 10 }}>
                      {requiredFiled(schema.sourceInfoYear.validators, schema.sourceInfoYear.label)}
                    </ControlLabel>
                    <Controller
                      key={schema.sourceInfoYear.name}
                      name={schema.sourceInfoYear.name}
                      control={control}
                      rules={isValidators(schema.sourceInfoYear.validators)}
                      defaultValue={schema.sourceInfoYear.value}
                      render={(props) => {
                        return (
                          <SelectPicker
                            size="lg"
                            style={{ marginLeft: 10 }}
                            searchable={true}
                            value={props.value}
                            data={schema.sourceInfoYear.options}
                            placeholder={schema.sourceInfoYear.hint}
                            onChange={(value) => {
                              setValue(schema.sourceInfoYear.name, value)
                            }}
                          />
                        )
                      }}
                    />
                  </FormGroup>
                </Form>
              </Col>
            )}

            {schema.impactOfProblem && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <CKEditorFrom
                  schema={schema.impactOfProblem}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.effectOnStudents && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <CKEditorFrom
                  schema={schema.effectOnStudents}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}
          </Row>
        </Grid>
      </Panel>
    </>
  )
}

const styles = {
  personstyles: {
    width: 90,
    marginBottom: 5,
  },
  detailstyles: {
    width: 90,
  },
  rowStyles: {
    marginLeft: 20,
  },
  percentStyles: {
    width: 70,
    marginBottom: 5,
  },
  percentDetailStyles: {
    width: 70,
  },
  preLabelStyle: {
    // width: '220px',
    textAlign: 'left',
  },
  leftWidth110: {
    width: '110px',
    textAlign: 'left',
  },
  marginTop10: {
    marginTop: 10,
  },
}
